import makeStyles from "@mui/styles/makeStyles";

// eslint-disable-next-line import/prefer-default-export
export const useStyles = makeStyles((theme) => ({
  form: {
    width: "100%",
  },
  submit: {
    margin: theme.spacing(2, 0, 2),
  },
  nameFields: {
    display: "flex",
    marginTop: theme.spacing(2),
  },
  nameField: {
    marginRight: theme.spacing(2),
  },
  inputField: {
    marginTop: theme.spacing(1),
  },
  blockInputField: {
    marginTop: theme.spacing(1),
    display: "block",
    width: "100%",
  },
  checkBox: {
    backgroundColor: "#f9f9f9",
    border: "1px solid #d3d3d3",
    paddingTop: "0.5rem",
    paddingBottom: "0.5rem",
    borderRadius: 3,
  },
  required: {
    fontSize: "0.7rem",
    marginLeft: 6,
    color: theme.palette.grey[600],
  },
  buttonStyle: {
    textTransform: "none",
  },
}));

export const invalidPasswords = [
  "password",
  "passwd",
  "test",
  "admin",
  "administrator",
  "sysadmin",
];

export const PASSWORD_REGEXP =
  /^(?=.*[a-zA-Z])(?=.*\d)([A-Za-z\d\s!"#$%&'()*\\\-^@[\];:,./=~|`{+}<>?_]+)$/;
